module.exports=function(scope){ return `curl -X POST \
'https://your.internal.zoomserver.instance.url/age-check' \
-H 'Content-Type: application/json' \
-H 'X-User-Agent: INSERT_X_USER_AGENT_VALUE_HERE' \
-d '{
  "faceMap": INSERT_FACEMAP_DATA_AS_BASE64_HERE,
  "targetAge": INSERT_TARGET_AGE_GROUP_HERE,
  "auditTrailImage": INSERT_AUDIT_TRAIL_IMAGE_DATA_AS_BASE64_HERE,
  "lowQualityAuditTrailImage": INSERT_LOW_QUALITY_AUDIT_TRAIL_IMAGE_DATA_AS_BASE64_HERE
}'
`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/bash/age-check.bash.tpl